import React from "react";
import "antd/dist/antd.css";
import MessageBox from "../../assets/images/Message.png";
import { Col, Row } from "@mtm/components";
import CommonBgStyles from "../../BackgroundCircles.module.scss";
import Styles from "./Message.module.scss";

type Props = {
  emailId: string;
};

const Message: React.FC<Props> = ({ emailId }) => {
  return (
    <>
      <div className="container">
        <div className={CommonBgStyles.bg_circle} />
        <Row className={Styles.messagePosition}>
          <Col span={24} lg={12} xl={12}>
            <img
              src={MessageBox}
              alt="MessageBox"
              className={Styles.messageImageWidth}
            />
          </Col>
          <Col lg={1} xl={2}/>
          <Col span={24} lg={11} xl={10}>
            <div className={Styles.messageTextGap}>
              <p className={Styles.messageHeading}>Verify Your Email</p>
              <div className={"subTextFont " + Styles.messageIndication}>
                Please check your email <b>{emailId}</b> for further
                instructions.
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default Message;
